import React, { useState, useEffect } from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContactData,
  postInquiryData,
  fetchDegreeData,
} from "../../redux/slicer/contactUsSlice";
import Preloader from "../../assets/sab.jpeg";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import ContactusImg from "../../assets/Banners/ContactUs.jpg"
function ContactUs() {
  const dispatch = useDispatch();

  const {
    data: contactData,
    loading: contactLoading,
    error: contactError,
  } = useSelector((state) => state.contact.contact);

  const {
    data: degreeData,
    loading: degreeLoading,
    error: degreeError,
  } = useSelector((state) => state.contact.degree);

  const [formData, setFormData] = useState({
    first_name: "",
    surname: "",
    contact_no: "",
    email: "",
    message: "",
    al_year: "",
    degree_program: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    dispatch(fetchContactData());
    dispatch(fetchDegreeData());
  }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const currentYear = new Date().getFullYear();
  const alYearOptions = Array.from(
    { length: currentYear - 2000 + 1 },
    (_, index) => 2000 + index
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    const response = await dispatch(postInquiryData(formData));

    if (response.success) {
      setSuccessMessage(response.message);
      setFormData({
        first_name: "",
        surname: "",
        contact_no: "",
        email: "",
        al_year: "",
        degree_program: "",
        message: "",
      });
    } else {
      setErrorMessage(response.message);
    }
  };

  // if (contactLoading || degreeLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (contactError || degreeError) {
  //   return <div>Error: {contactError || degreeError}</div>;
  // }

  if (contactLoading || degreeLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (contactError || degreeError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error: {contactError || degreeError}
        </p>
      </div>
    );
  }
  const { address, phone_no, email_address, map } = contactData[0] || {};

  return (
    <div>
      {/* Hero Section */}
      <div className="relative w-full mx-auto">
        <div className="overflow-hidden w-full  h-[300px] sm:h-[400px]">
          <img
            // src="https://files.unitasterdays.com/bespoke-pages/bpid654/img2023816670.jpg"
            src={ContactusImg}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-3xl sm:text-5xl font-bold  font-titillium">
              Contact Us
            </h2>
            <p className="text-base sm:text-lg mt-4 sm:mt-10font-inter">
           
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="px-4 sm:px-6 lg:px-16 py-6 mt-6 flex flex-col items-center justify-center gap-6">
        <div className="bg-[#2E0249] w-full max-w-[1000px] rounded-lg px-6 py-8 sm:px-10 sm:py-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Section */}
            <div>
              <p className="text-2xl lg:text-4xl text-white font-bold text-left font-titillium">
                Let’s discuss & decide your{" "}
                <a href="" className="text-[#A91079]">
                  future
                </a>{" "}
                with us.
              </p>
              <div className="flex flex-col gap-6 mt-6">
                <div className="flex items-center text-white text-lg ml-3">
                  <IoMail className="text-[#A91079] mr-3" />
                  <span className="font-inter">{email_address}</span>
                </div>
                <div className="border rounded border-primary-color w-[300px] h-[50px] bg-[#92288C36] ">
                  <div className="flex justify-start item-start ml-4">
                    <div className="flex justify-center item-center mt-3">
                      <span className="text-[#A91079] mt-1 text-left">
                        <FaPhoneAlt />
                      </span>
                      <label htmlFor="" className="text-white ml-3 font-inter text-left">
                        {phone_no}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex items-center text-white text-lg ml-3">
                  <FaLocationDot className="text-[#A91079] mr-3" />
                  <span className="font-inter">{address}</span>
                </div>
                <div
                  style={{
                    borderRadius: "16px",
                    overflow: "hidden",
                  }}
                  className="mt-4"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: map,
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Inquiry Form */}
            <div className="bg-white rounded-lg px-6 py-8">
              <h2 className="text-primary-color text-3xl mb-6  font-titillium">
                Inquiry
              </h2>
              {successMessage && (
                <div className="mb-4 text-green-600 text-center">
                  {successMessage}
                </div>
              )}
              {errorMessage && (
                <div className="mb-4 text-red-600 text-center">
                  {errorMessage}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="grid gap-y-4">
                  <input
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    value={formData.first_name}
                    onChange={handleInputChange}
                    className="peer w-full border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-3 mt-5"
                    required
                  />
                  <input
                    type="text"
                    name="surname"
                    placeholder="Last Name"
                    value={formData.surname}
                    onChange={handleInputChange}
                    className="peer w-full border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-3 mt-5"
                    required
                  />
                  <input
                    type="tel"
                    name="contact_no"
                    placeholder="Contact Number"
                    value={formData.contact_no}
                    onChange={handleInputChange}
                    className="peer w-full border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-3 mt-5"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="peer w-full border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-3 mt-5"
                    required
                  />
                  <select
                    name="al_year"
                    value={formData.al_year}
                    onChange={handleInputChange}
                    className="w-full border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-2 font-inter"
                    required
                  >
                    <option value="">Select AL Year</option>
                    {alYearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  <select
                    name="degree_program"
                    value={formData.degree_program}
                    onChange={handleInputChange}
                    className="w-full border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-2 font-inter"
                  >
                    <option value="">Select Degree Program</option>
                    {degreeData.map((degree) => (
                      <option key={degree.id} value={degree.program_name}>
                        {degree.program_name}
                      </option>
                    ))}
                  </select>{" "}
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="w-full border rounded px-4 py-2 focus:outline-none focus:border-primary-color"
                    required
                  />
                </div>
                <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-6">
                  <button
                    type="submit"
                    className="bg-primary-color text-white w-full sm:w-[180px] h-[50px] rounded-lg flex justify-center items-center"
                  >
                    <div className="flex justify-center items-center">
                      <span className="mr-3 mt-1 font-inter">
                        <FaTelegramPlane />
                      </span>
                      Submit
                    </div>
                  </button>

                  <button
                    type="reset"
                    className="bg-gray-100 text-primary-color w-full sm:w-[180px] h-[50px] rounded-lg font-inter"
                    onClick={() =>
                      setFormData({
                        first_name: "",
                        surname: "",
                        contact_no: "",
                        email: "",
                        message: "",
                        al_year: "",
                        degree_program: "",
                      })
                    }
                  >
                    Reset
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="px-6 pt-4 pb-2 flex justify-end mb-5">
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
        >
          <FaArrowUp />
        </button>
      </div> */}
    </div>
  );
}

export default ContactUs;
